import React, { Fragment } from 'react';
import { Item, Divider } from 'semantic-ui-react';

import PassengersList from './PassengersList';
import AddPassenger from './AddPassenger';
import { isCrmStateMoveable } from '../../../../utils/passengersMoveableCrmStates';

const ViewContainer = ({
  id,
  passengerAmount,
  crmState,
  claimsPassengerTickets,
  paymentData,
  passengerTicketId,
  onClaimUpdated,
  previewOnly,
  flightId,
  affiliate,
  hideLoading,
  showLoading,
  paxBankAccountHolder,
  donatedAmount
}) => {
  const commomProps = {
    id,
    onClaimUpdated,
    hideLoading,
    showLoading
  };
  return (
    <Fragment>
      <Divider />
      <Item>
        <Item.Content>
          <Item.Header>
            {`Passenger${passengerAmount === 1 ? '' : 's'}`}
          </Item.Header>
          <Divider hidden />
          <PassengersList
            crmState={crmState}
            claimsPassengerTickets={claimsPassengerTickets}
            paymentData={paymentData}
            passengerTicketId={passengerTicketId}
            previewOnly={previewOnly}
            contact={false}
            paxBankAccountHolder={paxBankAccountHolder}
            donatedAmount={donatedAmount}
            {...commomProps}
          />
          {!previewOnly && isCrmStateMoveable(crmState) && (
            <AddPassenger
              key={id}
              flightId={flightId}
              affiliate={affiliate}
              claimCrmState={crmState}
              {...commomProps}
            />
          )}
        </Item.Content>
      </Item>
    </Fragment>
  );
};

export default ViewContainer;



// WEBPACK FOOTER //
// ./src/component/ClaimPage/ClaimDetails/Passengers/index.js